// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__117gX","author":"Table_author__1xZ74","authorImage":"Table_authorImage__18D0f","unreadRow":"Table_unreadRow__1rijc"};